import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="15166" id="call-to-action" className="relative w-full py-[120px] bg-background text-foreground bg-gradient-to-br from-[#0a2e1f] via-secondary to-[#051a12] overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-20" style={{
      backgroundImage: `
            linear-gradient(rgba(34, 197, 94, 0.15) 1px, transparent 1px),
            linear-gradient(90deg, rgba(34, 197, 94, 0.15) 1px, transparent 1px)
          `,
      backgroundSize: "80px 80px",
      maskImage: "radial-gradient(circle at center, black 40%, transparent 100%)",
      WebkitMaskImage: "radial-gradient(circle at center, black 40%, transparent 100%)"
    }} aria-hidden="true" />

      {}
      <div ref={ref} className={`container mx-auto px-4 relative z-10 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h2 className="text-4xl md:text-5xl lg:text-7xl font-bold text-white mb-6 tracking-tighter max-w-4xl">
          Nooit meer een lege batterij met <span className="text-[#ffe838]">Zap</span><span className="text-[#70cf70]">GO!</span>
        </h2>
        
        <p className="text-lg md:text-xl text-white/80 max-w-2xl mb-10 leading-relaxed font-sans">
          Vind een <span className="text-[#ffe838]">Zap</span><span className="text-[#70cf70]">GO!</span>-station bij u in de buurt of word partner en verhoog de klanttevredenheid in uw horecazaak. De slimme, duurzame oplossing voor modern gemak.
        </p>

        <Link to="/PartnersPage">
          <Button size="lg" className="bg-white text-primary hover:bg-white/95 text-lg px-10 py-7 h-auto rounded-full shadow-[0_0_30px_rgba(34,197,94,0.3)] hover:shadow-[0_0_40px_rgba(34,197,94,0.5)] transition-all duration-300 group font-bold">
            Word nu Partner
            <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
          </Button>
        </Link>
      </div>
    </section>;
}